import { CONSTS } from 'config/objectConst'

const typeToCN = {
	[CONSTS.AVAILABLE_ACTIONS.Connect.Type]: 'connect',

	[CONSTS.AVAILABLE_ACTIONS.EndorseSkill.Type]: 'endorse-a-skill',

	[CONSTS.AVAILABLE_ACTIONS.Follow.Type]: 'follow',

	[CONSTS.AVAILABLE_ACTIONS.Message.Type]: 'message',

	[CONSTS.AVAILABLE_ACTIONS.ReactOnPost.Type]: 'like-a-post',

	[CONSTS.AVAILABLE_ACTIONS.ScrapeProfile.Type]: 'scrape-profile',

	[CONSTS.AVAILABLE_ACTIONS.VisitProfile.Type]: 'view-profile'
}

export const getTypeCN = (type: string) => {
	const value = typeToCN[type]

	if (value) {
		return value
	}

	throw new Error(`Not supported action type ${type}`)
}
